import React, { useEffect, useState } from "react";
import { Route, Switch, useHistory, Redirect } from "react-router-dom";
import Spinner from "react-bootstrap/Spinner";

import styled from "@emotion/styled";

import Nav from "@/components/Nav";
import Footer from "@/components/Footer";
import LoadingComponent from "@/components/Loading";

import { useAuthStore, useLoadingStore, useModalStore } from "@/stores/hooks";

import routes from "./routes";

const Page = styled.div`
  min-width: 1240px;
  display: flex;
  flex-direction: column;
  min-height: 100vh;
`;
const Content = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  height: 100%;
`;

const LoadingBackdrop = styled.div`
  display: flex;
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 2000;
`;

const LoadingMessage = styled.div`
  font-size: 16px;
  font-weight: bold;
  color: #fff;
  margin-top: 10px;
`;

const RestoringComponent = () => {
  const [message, setMessage] = useState("");

  useEffect(() => {
    setTimeout(() => {
      setMessage("통신에 문제가 생겼습니다. 새로고침 후 다시 시도해주세요.");
    }, 60000);
  }, []);

  return (
    <div style={{ display: "flex", justifyContent: "center", alignItems: "center", height: "100vh" }}>
      <LoadingBackdrop>
        <Spinner animation="border" variant="light" />
        <LoadingMessage>{message}</LoadingMessage>
      </LoadingBackdrop>
    </div>
  );
};

export default function Router() {
  const { user, restoring } = useAuthStore().state;
  const { ...authActions } = useAuthStore();

  const { loading } = useLoadingStore().state;

  const { modals } = useModalStore().state;

  const history = useHistory();

  const [fromReferer] = useState(history.location.pathname || "/");

  useEffect(async () => {
    if (authActions.checkAlreadySignIn()) {
      authActions.signInExistingUser();
      history.push(fromReferer);
    } else {
      try {
        await authActions.restore();
        history.push(fromReferer);
      } catch (_err) {
        history.push("/");
      }
    }
  }, []);

  if (restoring) {
    return (
      <RestoringComponent />
    );
  }

  return (
    <>
      <Switch>
        {routes.map((route) => (
          <Route exact={route.exact} key={route.name} path={route.path}>
            {route.private && !user && <Redirect to="/" />}

            {route.csCommunication &&
              user &&
              !user.canAccessCsCommunication && (
                <Redirect to="/deliveries" />
              )}

            {((route.private && user) || !route.private) &&
              !(
                route.csCommunication &&
                user &&
                !user.canAccessCsCommunication
              ) && (
              <Page>
                {route.nav && (
                  <Nav
                    routeName={route.name}
                    scanner={route.name === "DeliveriesForScanner"}
                  />
                )}
                <Content>
                  <route.component />
                </Content>
                <Footer />
              </Page>
            )}
          </Route>
        ))}
      </Switch>
      {modals.map((modal) => modal)}
      {loading && <LoadingComponent />}
    </>
  );
}
